$(".sl-v2-mobile-main-menu").on(
  "click",
  ".sl-nav-all-filters-title-box",
  function () {
    var wd_nav_rest = $(this)
      .parent(".sl-nav-all-filters-title")
      .siblings()
      .find(".sl-nav-all-filters-item");
    var wd_nav_menu = $(this).siblings(".sl-nav-all-filters-item");
    if (wd_nav_menu.css("display") == "block") {
      $(this).css("color", "#cccccc");
      wd_nav_menu.slideUp();
      $(this).find(".sl-nav-sub").addClass("sl-nav-all-hidden");
      $(this).find(".sl-nav-plus").removeClass("sl-nav-all-hidden");
    } else {
      $(this).css("color", "#ffffff");
      $(this)
        .parent(".sl-nav-all-filters-title")
        .siblings(".sl-nav-all-filters-title")
        .find(".sl-nav-all-filters-title-box")
        .css("color", "#cccccc");
      wd_nav_menu.slideDown();
      wd_nav_rest.slideUp();
      $(this).find(".sl-nav-sub").removeClass("sl-nav-all-hidden");
      $(this).find(".sl-nav-plus").addClass("sl-nav-all-hidden");
      wd_nav_rest.siblings().find(".sl-nav-sub").addClass("sl-nav-all-hidden");
      wd_nav_rest
        .siblings()
        .find(".sl-nav-plus")
        .removeClass("sl-nav-all-hidden");
    }
  }
);
